import RegionItem from '@pages/sales-network/shared/RegionItem';
import { CountryEnum } from '@api/types/CountryEnum';
import { useGetPartnersByCountryQuery } from '@api/baseApi';
import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';



interface RegionsListProps {
	selectedRegion: string,
	country: CountryEnum,
}


const RegionsList = (props: RegionsListProps): JSX.Element => {
	const { selectedRegion, country } = props;

	const { data, isLoading, isFetching, isError } = useGetPartnersByCountryQuery({ country });

	if (isError) return (
		<div className='regions-list'>
			<p className='error-message'>Chyba při načítání</p>
		</div>
	)

	if (isLoading || isFetching) return (
		<div className='regions-list'>
			<p className='loading-message'><LoadingSpinner /></p>
		</div>
	)

	return (
		<div className='regions-list'>

			{data && data.map(x =>
				<RegionItem
					region={x}
					selectedRegion={selectedRegion}
					key={`regions-list-${x.key}`} />)}
		
		</div>
	);
};

export default RegionsList;